"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { IconSun, IconMoon } from "./icons";

/**
 * Light/dark toggle. Cycles between "light" and "dark" (not "system")
 * once clicked, so the choice is explicit and predictable. Renders a
 * neutral placeholder until mounted to avoid a server/client markup
 * mismatch, since the resolved theme is only known in the browser.
 */
export default function ThemeToggle({ className = "" }: { className?: string }) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={mounted ? `Switch to ${isDark ? "light" : "dark"} mode` : "Toggle theme"}
      className={`flex h-10 w-10 items-center justify-center rounded-lg border border-ink-900/10 text-ink-700 transition-colors hover:bg-ink-900/[0.04] hover:text-ink-900 dark:border-white/15 dark:text-white/70 dark:hover:bg-white/[0.06] dark:hover:text-white ${className}`}
    >
      {mounted ? (
        isDark ? (
          <IconSun className="h-[18px] w-[18px]" />
        ) : (
          <IconMoon className="h-[18px] w-[18px]" />
        )
      ) : (
        <span className="block h-[18px] w-[18px]" />
      )}
    </button>
  );
}
